import { render, staticRenderFns } from "./ChatSidebarMessageList.vue?vue&type=template&id=08da3375&scoped=true&"
import script from "./ChatSidebarMessageList.vue?vue&type=script&lang=js&"
export * from "./ChatSidebarMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ChatSidebarMessageList.vue?vue&type=style&index=0&id=08da3375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08da3375",
  null
  
)

export default component.exports